/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserInformationViewModel
 */
export interface UserInformationViewModel {
    /**
     * 
     * @type {string}
     * @memberof UserInformationViewModel
     */
    institutionAgentCode: string;
    /**
     * 
     * @type {string}
     * @memberof UserInformationViewModel
     */
    clientNumber: string;
    /**
     * 
     * @type {string}
     * @memberof UserInformationViewModel
     */
    sanpayCode: string;
    /**
     * 
     * @type {string}
     * @memberof UserInformationViewModel
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof UserInformationViewModel
     */
    surname: string;
    /**
     * 
     * @type {string}
     * @memberof UserInformationViewModel
     */
    emailAddress: string;
}

/**
 * Check if a given object implements the UserInformationViewModel interface.
 */
export function instanceOfUserInformationViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "institutionAgentCode" in value;
    isInstance = isInstance && "clientNumber" in value;
    isInstance = isInstance && "sanpayCode" in value;
    isInstance = isInstance && "firstName" in value;
    isInstance = isInstance && "surname" in value;
    isInstance = isInstance && "emailAddress" in value;

    return isInstance;
}

export function UserInformationViewModelFromJSON(json: any): UserInformationViewModel {
    return UserInformationViewModelFromJSONTyped(json, false);
}

export function UserInformationViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserInformationViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'institutionAgentCode': json['InstitutionAgentCode'],
        'clientNumber': json['ClientNumber'],
        'sanpayCode': json['SanpayCode'],
        'firstName': json['FirstName'],
        'surname': json['Surname'],
        'emailAddress': json['EmailAddress'],
    };
}

export function UserInformationViewModelToJSON(value?: UserInformationViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'InstitutionAgentCode': value.institutionAgentCode,
        'ClientNumber': value.clientNumber,
        'SanpayCode': value.sanpayCode,
        'FirstName': value.firstName,
        'Surname': value.surname,
        'EmailAddress': value.emailAddress,
    };
}

